/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2024-05-16 13:16:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2024-05-16 13:16:37
 * @FilePath: /dbrank_b/src/routes/visualChart/P25/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import SelectLogo from '../components/SelectLogo';
import logo from '../components/image/logo.png';


function formatThousands(event) {
  if (event.target.innerText) {
    event.target.innerText = event.target.innerText
      .replace(/(\d),(\d)/g, "$1$2")
      .replace(/(\d)(?=(\d{3}\D?)+(\D|$))/g, "$1,");
  }
}


class P25 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }


  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <div className={s.PageBox}>
          <div className={s.p25Box}>
            <div className={s.headerBox}>
              <img className={s.headerImage} src={logo}></img>
              <div className={s.headerNo}>
                <div contentEditable className={s.headerNo_1}>周榜/</div>
                <div contentEditable className={s.headerNo_2}>No.1</div>
              </div>
            </div>

            <div className={s.content}>
              <div className={s.brandLogoBox}>
                <SelectLogo className={s.brandLogo} />
              </div>

              <div className={s.content_box1}>
                <div>
                  <span contentEditable>案例编号</span><span contentEditable spellCheck="false">D240510</span>
                </div>
                <div>
                  <span contentEditable>案例名称</span><span contentEditable style={{ fontWeight: 'bold' }}>饿了么《虫启惊蛰》Campaign</span>
                </div>
                <div>
                  <span contentEditable>监测窗口</span><span contentEditable>2024年3月2日-3月8日</span>
                </div>
              </div>

              <div className={s.content_box2}>
                <div className={s.content_box2_title} contentEditable>案例介绍</div>
                <div className={s.content_box2_inner} contentEditable>微雨众卉新，一雷惊蛰始。3月5日，饿了么发布惊蛰短片《虫启惊蛰》，以云南傣族村落里吃虫的食俗展开，在春天的自然角落里寻找虫子的身影，从孩子视角讲述勇敢的主张「惊蛰吃吃虫，今年不会怂」。</div>
              </div>

              <div className={s.content_box3}>
                <div className={s.content_box3_tag1}>
                  <div contentEditable>传播效果价值</div>
                  <div contentEditable onBlur={formatThousands}>26,351,512<span style={{ paddingLeft: '2px', fontSize: '12px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
                <div className={s.content_box3_tag2}>
                  <div contentEditable>内容总条数</div>
                  <div contentEditable onBlur={formatThousands}>4,877<span style={{ paddingLeft: '2px', fontSize: '14px' }} contentEditable>条</span></div>
                </div>
                <div className={s.content_box3_tag3}>
                  <div contentEditable>内容传播度</div>
                  <div contentEditable>2.58<span style={{ paddingLeft: '2px' }} contentEditable>%</span></div>
                </div>
              </div>

              <div className={s.content_box4}>
                <div className={s.content_box4_tag1}>
                  <div contentEditable>用户参与度</div>
                  <div contentEditable><span style={{ fontSize: '18px', fontWeight: 'bold' }}>26.2</span><span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
                <div className={s.content_box4_tag2}>
                  <div contentEditable>全网好感度</div>
                  <div contentEditable><span style={{ fontSize: '18px', fontWeight: 'bold' }}>26</span><span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
              </div>

              <div className={s.content_box5}>
                <div className={s.content_box5_tag1}>
                  <div contentEditable>传播引爆度</div>
                  <div contentEditable>2.24<span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
                <div className={s.content_box5_tag2}>
                  <div contentEditable>TOP10内容引爆力合计</div>
                  <div contentEditable onBlur={formatThousands}>4,877<span style={{ paddingLeft: '5px', fontSize: '8px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
                <div className={s.content_box5_tag3}>
                  <div contentEditable>单条内容引爆力均值</div>
                  <div contentEditable onBlur={formatThousands}>743,950<span style={{ paddingLeft: '5px', fontSize: '8px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
              </div>

              <div className={s.content_box6} contentEditable>
                <span style={{ fontWeight: 'bold' }}>案例类型:</span> #饿了么、#互联网、#节点营销、#春日营销、#蹭热点
              </div>
            </div>

            <div className={s.content_text1} contentEditable>
              <span style={{ fontWeight: 'bold' }}>[数据来源]</span> 数据来源覆盖新闻媒体类（中央级媒体、泛财经媒体、行业媒体、大众媒体等）+网络资讯类（今日头条、一点资讯、腾讯新闻等网站/APP）+社交媒体（微博、知乎）+自媒体平台（微信号、头条号、百家号等）+消费社区类（小红书、什么值得买等）+短视频类（抖音、快手等）
            </div>
            <div className={s.content_text2} contentEditable>
              <span style={{ fontWeight: 'bold' }}>[研究方法]</span> 基于新闻媒体报道和用户UGC内容，基于『数字品牌榜』专有计算模型得出。
            </div>

            <div className={s.bootomLogoBox}>
              <div className={s.bootomLogo}></div>
            </div>

          </div>

          <div className={s.p25Box_2}>
            <div className={s.headerBox_box2}>
              <img className={s.headerImage_box2} src={logo}></img>
            </div>
            <div className={s.headerBox2}>
              <div className={s.headerBox2_number}>
                <div contentEditable className={s.headerNoBox2_1}>May.</div>
                <div contentEditable className={s.headerNoBox2_2}>2024</div>
              </div>
              <div className={s.headerBox2_logo}>
                <SelectLogo className={s.brandLogo} />

              </div>
              <div className={s.headerBox2_text}>
                <div>
                  <span contentEditable>案例编号</span><span contentEditable>D240510</span>
                </div>
                <div>
                  <span contentEditable>案例名称</span><span contentEditable style={{ fontWeight: 'bold' }}>淘宝生日周免单活动Campaign</span>
                </div>
                <div>
                  <span contentEditable>起止时间</span><span contentEditable>2024年5月6日-5月10日</span>
                </div>
              </div>
            </div>

            <div className={s.inner_box}>
              <div className={s.inner_box1}>
                <div className={s.inner_box_tag1}>
                  <div contentEditable>传播效果价值</div>
                  <div contentEditable onBlur={formatThousands}>26,351,512<span style={{ paddingLeft: '2px', fontSize: '16px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
                <div className={s.inner_box_tag2}>
                  <div contentEditable>内容总条数</div>
                  <div contentEditable onBlur={formatThousands}>4,877<span style={{ paddingLeft: '2px'}} contentEditable>条</span></div>
                </div>
                <div className={s.inner_box_tag3}>
                  <div contentEditable>内容传播数</div>
                  <div contentEditable>2.58<span style={{ paddingLeft: '2px' }} contentEditable>%</span></div>
                </div>
              </div>

              <div className={s.inner_box2}>
                <div className={s.inner_box2_tag1}>
                  <div contentEditable>用户参与度</div>
                  <div contentEditable><span>26.2</span><span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
                <div className={s.inner_box2_tag2}>
                  <div contentEditable>全网好感度</div>
                  <div contentEditable><span>26</span><span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
              </div>

              <div className={s.inner_box3}>
                <div className={s.inner_box3_tag1}>
                  <div contentEditable>传播引爆度</div>
                  <div contentEditable>2.24<span style={{ paddingLeft: '5px' }} contentEditable>%</span></div>
                </div>
                <div className={s.inner_box3_tag2}>
                  <div contentEditable>TOP10内容引爆力合计</div>
                  <div contentEditable onBlur={formatThousands}>4,877<span style={{ paddingLeft: '5px', fontSize: '14px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
                <div className={s.inner_box3_tag3}>
                  <div contentEditable>单条内容引爆力均值</div>
                  <div contentEditable onBlur={formatThousands}>743,950<span style={{ paddingLeft: '5px', fontSize: '14px', fontStyle: 'italic' }} contentEditable>DB</span></div>
                </div>
              </div>

              <div className={s.inner_box4} contentEditable>
                <span style={{ fontWeight: 'bold' }}>案例类型:</span> #淘宝、#互联网、#周年庆
              </div>

            </div>


            <div className={s.p25Box_2_bootomLogoBox}>
              <div className={s.p25Box_2_bootom_text}> 
                <div className={s.p25Box_2_bootom_text1} contentEditable>NO. 1</div>
                <div className={s.p25Box_2_bootom_text2} contentEditable>5月第1周品牌传播案例</div>

              </div>
              <div className={s.bootomLogo_2}></div>
            </div>


          </div>
        </div>

      </Stage>
    );
  }
}

export default withStyles(s)(P25);



// WEBPACK FOOTER //
// src/routes/visualChart/P25/index.js